import { v4 as uuidv4 } from "uuid";

/**
 * 获取或生成并缓存 anonymousId
 */
export const getAnonymousId = (): string => {
    const storageKey = "anonymous_id";
    let anonymousId = localStorage.getItem(storageKey);

    if (!anonymousId) {
        anonymousId = uuidv4();
        localStorage.setItem(storageKey, anonymousId);
    }

    return anonymousId;
};
